module.exports = __webpack_public_path__ + "static/gembewatson-logo-f6b5f32b14536523a57b452c10188216.svg";